<!-- vertical layout -->
<app-vertical *ngIf="isVerticalLayoutRequested()" [layoutWidth]="layoutWidth" [sidebarTheme]="leftSidebarTheme"
  [sidebarType]="leftSidebarWidth"></app-vertical>

<!-- horizontal layout -->
<app-horizontal *ngIf="isHorizontalLayoutRequested()" [layoutWidth]="layoutWidth"></app-horizontal>

<!-- right sidebar-->
<app-rightsidebar></app-rightsidebar>
